module.exports = __webpack_public_path__ + "img/blue54.af000d35.svg";